import Footer from "../../components/Footer/Footer";
import React from "react";
import Navbar from "../../components/Navbar/Navbar";

const sectionHeading = "mt-12 mb-4 text-center text-2xl font-bold text-neutral-800 md:text-4xl";
const description = "mt-4 text-center text-base leading-loose text-neutral-600 md:text-xl";
const list = "mx-auto max-w-3xl space-y-2.5 pl-5 text-left text-base leading-loose text-neutral-600 marker:text-black md:text-lg [&_strong]:text-neutral-800";

const About = () => {
    return (
        <main className="flex flex-1 flex-col">
            <Navbar />
            <div className="mx-auto w-full max-w-5xl px-4 sm:px-8">
                <h1 className="page-heading mb-0 md:mb-0">About Us</h1>
                <p className={description}>
                    Welcome to <strong>HMR Decor</strong>, your premier destination for exquisite wedding decor. Our mission is to transform your wedding day into a breathtakingly beautiful and unforgettable event. With a keen eye for detail and a passion for creating magical moments, we specialize in designing and crafting decor that captures the essence of your love story.
                </p>

                <h2 className={sectionHeading}>Why Choose Us?</h2>
                <p className={description}>Choosing <strong>HMR Decor</strong> means choosing a partner who is as passionate about your wedding as you are. We are committed to providing:</p>
                <ul className={`${list} mt-4 list-disc`}>
                    <li><strong>Personalized Service:</strong> Your wedding is unique, and we tailor our services to meet your specific needs and preferences.</li>
                    <li><strong>High-Quality Decor:</strong> We use only the finest materials and latest design trends to create decor that is both stylish and durable.</li>
                    <li><strong>Attention to Detail:</strong> We leave no stone unturned in ensuring that every element of your decor is perfect, from the largest centerpiece to the smallest detail.</li>
                </ul>

                <h2 className={sectionHeading}>Contact Us</h2>
                <p className={description}>Ready to bring your dream wedding to life? Contact us today to schedule a consultation and discover how we can create the perfect setting for your special day.</p>
                <ul className={`${list} mt-4 list-disc break-words`}>
                    <li><strong>Email:</strong> hmrdecor.co@gmail.com</li>
                    <li><strong>Phone:</strong> (437)-982-1850</li>
                </ul>

                <h2 className={sectionHeading}>Our Social Media</h2>
                <p className={description}>Follow us on social media to see our latest creations and get inspired for your own wedding!</p>
                <ul className={`${list} mt-4 list-disc`}>
                    <li><strong>Instagram:</strong> <a className="text-blue-600 underline" href="https://www.instagram.com/hmr.decor/" target="_blank" rel="noreferrer">@hmr.decor</a></li>
                    <li><strong>Tik Tok:</strong> <a className="text-blue-600 underline" href="https://www.tiktok.com/@hmr.decor" target="_blank" rel="noreferrer">@hmr.decor</a></li>
                </ul>
            </div>
            <Footer />
        </main>
    );
}

export default About;
